import React from 'react';

const CreativeTemplate = ({ resumeData }) => {
    return (
        <div className="bg-white w-[210mm] min-h-[297mm] shadow-2xl origin-top transform scale-[0.4] md:scale-[0.65] lg:scale-[0.85] xl:scale-100 transition-transform duration-300 text-slate-800 font-sans flex flex-col" id="resume-preview">

            {/* Header */}
            <div className="bg-slate-900 text-white p-[15mm] pb-[10mm]">
                <h1 className="text-5xl font-bold mb-4 tracking-tight">{resumeData.personal.fullName || "Your Name"}</h1>
                <div className="flex flex-wrap gap-6 text-sm text-slate-300 font-medium">
                    {resumeData.personal.email && <span className="flex items-center gap-2">{resumeData.personal.email}</span>}
                    {resumeData.personal.phone && <span className="flex items-center gap-2">{resumeData.personal.phone}</span>}
                    {resumeData.personal.location && <span className="flex items-center gap-2">{resumeData.personal.location}</span>}
                </div>
            </div>

            <div className="flex flex-1">
                {/* Left Column */}
                <div className="w-[70mm] bg-slate-50 p-[10mm] border-r border-slate-200">
                    {/* Skills */}
                    {resumeData.skills.length > 0 && (
                        <div className="mb-10">
                            <h2 className="text-sm font-black uppercase tracking-widest text-blue-600 mb-6">Skills</h2>
                            <div className="flex flex-col gap-3">
                                {resumeData.skills.map((skill, idx) => (
                                    <span key={idx} className="text-sm font-medium text-slate-700 border-b border-slate-200 pb-2">
                                        {skill}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Education - Moved to side column for this layout */}
                    {resumeData.education.length > 0 && (
                        <div className="mb-10">
                            <h2 className="text-sm font-black uppercase tracking-widest text-blue-600 mb-6">Education</h2>
                            <div className="space-y-6">
                                {resumeData.education.map((edu) => (
                                    <div key={edu.id}>
                                        <div className="font-bold text-slate-800">{edu.school}</div>
                                        <div className="text-sm text-slate-600 mb-1">{edu.degree}</div>
                                        <div className="text-xs font-medium text-slate-400">{edu.year}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {/* Right Column */}
                <div className="flex-1 p-[10mm] pt-[10mm]">
                    {/* Summary */}
                    {resumeData.personal.summary && (
                        <div className="mb-10">
                            <h2 className="text-sm font-black uppercase tracking-widest text-blue-600 mb-4">Profile</h2>
                            <p className="text-sm leading-relaxed text-slate-600">{resumeData.personal.summary}</p>
                        </div>
                    )}

                    {/* Experience */}
                    {resumeData.experience.length > 0 && (
                        <div className="mb-10">
                            <h2 className="text-sm font-black uppercase tracking-widest text-blue-600 mb-6">Experience</h2>
                            <div className="space-y-8">
                                {resumeData.experience.map((exp) => (
                                    <div key={exp.id} className="relative pl-6 border-l-2 border-slate-100">
                                        <div className="absolute -left-[5px] top-1.5 w-2 h-2 rounded-full bg-blue-600"></div>
                                        <div className="flex justify-between items-baseline mb-1">
                                            <h3 className="font-bold text-lg text-slate-800">{exp.role}</h3>
                                            <span className="text-xs font-bold text-slate-400 uppercase">{exp.startDate} - {exp.endDate}</span>
                                        </div>
                                        <div className="text-sm font-semibold text-blue-600 mb-3">{exp.company} {exp.location && `• ${exp.location}`}</div>
                                        <p className="text-sm leading-relaxed text-slate-600 whitespace-pre-line">{exp.description}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Custom Sections */}
                    {resumeData.sectionOrder.map((sectionId) => {
                        if (typeof sectionId === 'number') {
                            const section = resumeData.customSections.find(s => s.id === sectionId);
                            if (section && section.items.length > 0) {
                                return (
                                    <div key={sectionId} className="mb-10">
                                        <h2 className="text-sm font-black uppercase tracking-widest text-blue-600 mb-6">{section.title}</h2>
                                        <div className="space-y-6">
                                            {section.items.map((item) => (
                                                <div key={item.id}>
                                                    <div className="flex justify-between items-baseline mb-1">
                                                        <h3 className="font-bold text-lg text-slate-800">{item.title}</h3>
                                                        {item.subtitle && <span className="text-xs font-bold text-slate-400 uppercase">{item.subtitle}</span>}
                                                    </div>
                                                    {item.subtext && <div className="text-sm font-semibold text-blue-600 mb-2">{item.subtext}</div>}
                                                    {item.description && <p className="text-sm leading-relaxed text-slate-600 whitespace-pre-line">{item.description}</p>}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                );
                            }
                        }
                        return null;
                    })}
                </div>
            </div>
        </div>
    );
};

export default CreativeTemplate;
